import React, { Component } from 'react';

class ProjectDisplay extends Component {

  constructor(props) {
    super(props);
    this.handleSwitchClick = this.handleSwitchClick.bind(this);
    this.state = {
      switchSelection: `bp-mobile-${this.props.pid}`
    };
  }

  checkSelected(id) {
    return id === this.state.switchSelection;
  }

  handleSwitchClick(e) {
    e.preventDefault();

    const labelEl = e.currentTarget;
    const inputID = labelEl.getAttribute('for');
    const breakpoint = labelEl.getAttribute('data-breakpoint');
    this.props.onToolbarSwitchClick(breakpoint);
    this.setState({ switchSelection: inputID });
  }

  handleSwitchChange() {
    return {
      done: false
    };
  }

  render() {
    const pid = this.props.pid;

    return (
      <div className={this.props.breakpoint ? `project-display project-display-${this.props.breakpoint}` : "project-display"}>
        <div className="display-bar">
          <div className="display-titlebar">
            <span className="circles">
              <span className="circle" style={{color: '#ff3300' }}></span>
              <span className="circle" style={{color: '#ffa800' }}></span>
              <span className="circle" style={{color: '#00cc00' }}></span>
            </span>
            <span className="display-title">{this.props.title}</span>
          </div>
          {Object.values(this.props.breakpoints).length > 1 && (
            <div className="display-toolbar">
              <span className="toolbar-switch">
                {this.props.breakpoints.mobile && (
                  <input type="radio" name="breakpoints"
                      id={`bp-mobile-${pid}`}
                      checked={this.checkSelected(`bp-mobile-${pid}`)}
                      onChange={this.handleSwitchChange} />
                )}
                {this.props.breakpoints.mobile && (
                  <label title="Mobile"
                      htmlFor={`bp-mobile-${pid}`}
                      className={this.checkSelected(`bp-mobile-${pid}`) ? "active" : ""}
                      onClick={this.handleSwitchClick}
                      data-breakpoint="mobile">
                    <img src="./icon/fa/solid/mobile-alt.svg" alt="Mobile" />
                  </label>
                )}
                {this.props.breakpoints.tablet && (
                  <input type="radio" name="breakpoints"
                      id={`bp-tablet-${pid}`}
                      checked={this.checkSelected(`bp-tablet-${pid}`)}
                      onChange={this.handleSwitchChange} />
                )}
                {this.props.breakpoints.tablet && (
                  <label title="Tablet"
                      htmlFor={`bp-tablet-${pid}`}
                      className={this.checkSelected(`bp-tablet-${pid}`) ? "active" : ""}
                      onClick={this.handleSwitchClick}
                      data-breakpoint="tablet">
                    <img src="./icon/fa/solid/tablet-alt.svg" alt="Tablet" />
                  </label>
                )}
                {this.props.breakpoints.desktop && (
                  <input type="radio" name="breakpoints"
                      id={`bp-desktop-${pid}`}
                      checked={this.checkSelected(`bp-desktop-${pid}`)}
                      onChange={this.handleSwitchChange} />
                )}
                {this.props.breakpoints.desktop && (
                  <label title="Desktop"
                      htmlFor={`bp-desktop-${pid}`}
                      className={this.checkSelected(`bp-desktop-${pid}`) ? "active" : ""}
                      onClick={this.handleSwitchClick}
                      data-breakpoint="desktop">
                    <img src="./icon/fa/solid/desktop-alt.svg" alt="Desktop" />
                  </label>
                )}
              </span>
            </div>
          )}
        </div>
        <div className="display-window">
          <img src={this.props.image.src} srcSet={this.props.image.srcset || ""} alt=""/>
        </div>
      </div>
    );
  }

}

export default ProjectDisplay;



// WEBPACK FOOTER //
// ./src/components/ProjectDisplay.js